module.exports = __webpack_public_path__ + "static/img/pinpai-demo.a7bb3d32.jpg";